import React, { useState, useRef } from 'react'; // 1. useRef add kiya
import ReCAPTCHA from 'react-google-recaptcha'; // 2. Package import kiya
import Loading from '../components/Loading';
import OurLocations from '../components/OurLocations';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    companies: '',
    phone: '',
    source: '',
    message: '',
  });

  const [captchaToken, setCaptchaToken] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const recaptchaRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCaptchaChange = (token) => setCaptchaToken(token);

  const resetCaptcha = () => {
    setCaptchaToken(null);
    recaptchaRef.current?.reset();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 6. Check agar captcha fill nahi kiya
    if (!captchaToken) {
      alert('Please verify that you are not a robot!');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch('/script.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, captchaToken }),
      });

      if (!response.ok) {
        let errorMessage = 'There was an error sending your message. Please try again later.';
        try {
          const result = await response.json();
          if (result.message) errorMessage = result.message;
        } catch {
          // Keep the generic message if the server did not return JSON.
        }
        resetCaptcha();
        alert(errorMessage);
        return;
      }

      alert('Your message has been sent!');
      setFormData({ fullName: '', email: '', companies: '', phone: '', source: '', message: '' });
      resetCaptcha();
    } catch {
      resetCaptcha();
      alert('There was a connection error. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (<>
    <Loading />
    <div id="contact-us" className="section">
      <img src="/Assets/Contactus/Contactus.jpg" alt="ContactUs" className="section-image" />
      <div className="contactus">
        <h1>We’re<br /> The Complete Solution.<br />Connect With Us,<br />And Let’s See How We Can Bring Your Vision To Life.</h1>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group captcha-container">
            <input type="text" id="fullName" name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <input type="email" id="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <input type="tel" id="phone" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <input type="text" id="companies" name="companies" placeholder="Company" value={formData.companies} onChange={handleChange} />
          </div>
          <div className="form-group">
            <input type="text" id="source" name="source" placeholder="How did you hear about us?" value={formData.source} onChange={handleChange} />
          </div>
          <div className="form-group">
            <textarea id="message" name="message" placeholder="Message" value={formData.message} onChange={handleChange} required></textarea>
          </div>

          {/* 9. Button se pehle reCAPTCHA component add kiya */}
          <div className="form-group">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6LfRBpgtAAAAAPMjWmjUu3qEK-1TJ5EzOoBmuWj3" // Yahan apni asli site key dalein
              onChange={handleCaptchaChange}
              onExpired={() => setCaptchaToken(null)}
              onErrored={() => setCaptchaToken(null)}
            />
          </div>

          <button type="submit" disabled={isSubmitting} style={{ transition: 'all 0.8s' }} className="submits-btn">
            {isSubmitting ? 'Sending...' : 'Send'}
          </button>
        </form>
      </div>
      <OurLocations />
    </div>
  </>
  );
};

export default ContactUs;
